import { Navigate, useParams } from 'react-router-dom';

import Conference from '../components/Conference/Conference/Conference';
import SiteModules from '../components/Conference/Site/SiteModules';
import AgendaList from '../components/Conference/Agenda/AgendaList';
import GuestList from '../components/Conference/Guest/GuestList';
import GuestJourneyList from '../components/Conference/Guest/GuestJourneyList';
import LiveList from '../components/Conference/Live/LiveList';
import Live from '../components/Conference/Live/Live';
import LiveLimit from '../components/Conference/Live/LiveLimit';
import LiveWhitelist from '../components/Conference/Live/LiveWhitelist';
import LiveReplays from '../components/Conference/Live/LiveReplays';
import LiveComments from '../components/Conference/Live/LiveComments';
import SignUpData from '../components/Conference/Live/LiveSignUp/index.jsx';
import OrganizationList from '../components/Conference/Organization/OrganizationList';
import NewLabourExpenses from '../components/Conference/LaborFeeRecords';
import EvaluationList from '../components/Conference/Evaluation/EvaluationList';
import SignUp from '../components/Conference/SignUp';
import SignUpTemplate from '../components/Conference/SignUp/SignUpTemplate';
import SignIn from '../components/Conference/SignIn';
import SignInSetting from '../components/Conference/SignIn/SignInSetting';
import SignInDetail from '../components/Conference/SignIn/SignInDetail';
import SignInStatistics from '../components/Conference/SignIn/SignInStatistics';

import { CONFERENCE_WORKSPACE_ROUTE_BASE } from '../layouts/conferenceWorkspaceConfig';

/**
 * `/conf/conferences/:id/*` 未匹配子路径时回到工作空间根（项目信息）。
 */
function ConferenceWorkspaceUnknownRedirect() {
    const { id } = useParams();
    return <Navigate to={`${CONFERENCE_WORKSPACE_ROUTE_BASE}/${id}`} replace />;
}

/**
 * 会议项目工作空间内的全部子路由（统一 `:id` = 会议项目 ID）：
 * - index：项目信息（`Conference`，靠 `:id === 'new'` 走新增态）
 * - 一级子页：网站模块 / 日程 / 嘉宾 / 嘉宾行程 / 机构 / 报名 / 签到 / 劳务费 / 专家价值
 * - 直播详情系列：`lives/new`、`lives/:liveId/{,limit,whitelist,replays,comments,signup-data}`
 * - 报名模板：`signup-template/add`、`signup-template/:templateId/edit`
 *
 * 内层资源参数统一为具名子参数（`:liveId` / `:templateId`），与外层 `:id` 解耦，
 * 子组件中以 `params.id` 取会议项目 ID、`params.liveId` / `params.templateId` 取资源 ID。
 */
const conferenceWorkspaceLayoutRoutes = [
    { index: true, element: <Conference /> },
    { path: 'site-modules', element: <SiteModules /> },
    { path: 'agendas', element: <AgendaList /> },
    { path: 'guests', element: <GuestList /> },
    { path: 'guests/journeys', element: <GuestJourneyList /> },
    { path: 'organizations', element: <OrganizationList /> },

    // 直播
    { path: 'lives', element: <LiveList /> },
    { path: 'lives/new', element: <Live /> },
    { path: 'lives/:liveId', element: <Live /> },
    { path: 'lives/:liveId/limit', element: <LiveLimit /> },
    { path: 'lives/:liveId/whitelist', element: <LiveWhitelist /> },
    { path: 'lives/:liveId/replays', element: <LiveReplays /> },
    { path: 'lives/:liveId/comments', element: <LiveComments /> },
    { path: 'lives/:liveId/signup-data', element: <SignUpData /> },

    // 劳务 / 评价
    { path: 'laborfee', element: <NewLabourExpenses /> },
    { path: 'evaluation', element: <EvaluationList /> },

    // 报名签到
    { path: 'signup', element: <SignUp /> },
    { path: 'signup-template/add', element: <SignUpTemplate /> },
    { path: 'signup-template/:templateId/edit', element: <SignUpTemplate /> },
    { path: 'signin', element: <SignIn /> },
    { path: 'signin-setting', element: <SignInSetting /> },
    { path: 'signin-detail', element: <SignInDetail /> },
    { path: 'signin-statistics', element: <SignInStatistics /> },

    { path: '*', element: <ConferenceWorkspaceUnknownRedirect /> },
];

export default conferenceWorkspaceLayoutRoutes;
